<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {};
</script>

<style lang="less">
	.ai-link {
		cursor: pointer;
		color: #2563eb;
	}

	.ai-link:hover {
		color: rgb(80.6, 130.2, 239);
	}

	.ai-link-book {
		cursor: pointer;
		color: #2563eb;
	}
	.ai-link-book:hover {
		color: rgb(80.6, 130.2, 239);
	}
</style>
